<template>
   <inertia-link :href="link"
      class="themeButton group relative flex gap-2 items-center group px-4 py-3 text-white text-xs bg-sky-400 themeColor rounded-lg"
      :style="{ height: buttonSize, width: buttonSize, padding: buttonPadding, justifyContent: buttonAlign, alignItems: buttonAlign }"
      :class="buttonClass">
      <Icon v-if="icon" :icon="icon" :width="iconSize" :height="iconSize" />
      <span v-if="title">{{ title }}</span>
      <Transition>
         <span
            class="hidden transition-all group-hover:flex justify-center themeButtonTooltip text-gray-700 dark:text-gray-400"
            v-if="tooltip">{{ tooltip }}</span>
      </Transition>
   </inertia-link>
</template>
<script>
import { Icon } from '@iconify/vue';
export default {
   name: "Link",
   components: {
      Icon
   },
   props: {
      title: {
         type: String,
         default: "",
      },
      link: {
         type: String,
         default: ""
      },
      icon: {
         type: String,
         default: ""
      },
      buttonClass: {
         type: String,
         default: ""
      },
      tooltip: {
         type: String,
         default: ""
      },
      iconSize: {
         type: String,
         default: ""
      },
      buttonSize: {
         type: String,
         default: ""
      },
      buttonPadding: {
         type: String,
         default: ""
      },
      buttonAlign: {
         type: String,
         default: ""
      }
   },
   methods: {
   }
}
</script>